import { currentPeriod, type Period, type WeeklyHours } from '@/features/menu/servicePeriod';
import { menuFilterPeriod } from '@/features/menu/menuFilterPeriod';
import type { Closure } from '@/types/restaurant';

/** Period the ticket's Plats tab filters the carte by, per note kind.
 *
 *  Sur place: the guest is seated and eats NOW, so the current service
 *  decides — unchanged, including the between-services 'closed' that leaves
 *  the whole carte visible for a table opened out of hours.
 *
 *  Emporter: the same window the ONLINE emporter carte uses (`MenuPage`).
 *  `currentPeriod` alone says 'closed' between services and stops filtering,
 *  so the midi-only formules came back in front of the waiter while the site
 *  was already selling only the dinner ones. `menuFilterPeriod` narrows to
 *  the service still orderable today, and keeps 'closed' (full carte) when
 *  both services or none remain.
 */
export function ticketMenuPeriod(
  kind: 'dine_in' | 'takeaway',
  hours: WeeklyHours | null | undefined,
  now: Date,
  closures: Closure[],
  prepMinutes: number,
  tz?: string,
): Period {
  // SC-1081 — `tz` : fuseau du restaurant (ses horaires sont a son heure).
  if (kind === 'dine_in') return currentPeriod(now, hours, tz);
  return menuFilterPeriod(hours, now, closures, prepMinutes, tz);
}
